import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FabStyle, ButtonIcon, NgxFabComponent } from '@digipay/ngx-button';

@Component({
  selector: 'common-ui-components-temp-ngx-fab',
  standalone: true,
  imports: [CommonModule, NgxFabComponent],
  templateUrl: './temp-ngx-fab.component.html',
  styleUrl: './temp-ngx-fab.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TempNgxFabComponent {
  style = input<FabStyle>('extended');
  icon = input.required<ButtonIcon>();
}
